export enum ToothPositionFormat {
  FDI = "FDI",
  US = "US",
  FHIR = "FHIR",
}
